<template>
  <div>
    <div id="mainBody">
      <n-grid x-gap="12" :cols="5">
        <n-gi> </n-gi>
        <n-gi>
          <div class="list">
            <h2>网站导航</h2>
            <p @click="toHome">首页</p>
            <p @click="toUS">关于我们</p>
            <p @click="toProduct">产品中心</p>
            <p @click="toTheCase">解决方案</p>
            <p @click="toNews">新闻中心</p>
          </div>
        </n-gi>
        <n-gi>
          <div class="list">
            <h2>产品导航</h2>
            <p @click="toPage(0)">能耗在线监测系统</p>
            <p @click="toPage(1)">机动车尾气遥感监测系统</p>
            <p @click="toPage(2)">机动车黑烟智能抓拍系统</p>
            <p @click="toPage(3)">油烟在线监测系统</p>
            <p @click="toPage(4)">VOCs走航监测分析系统</p>
          </div>
        </n-gi>
        <n-gi>
          <div>
            <h2>联系我们</h2>
            <p>全国服务热线：</p>
            <p>400-1599-006</p>
          </div>
        </n-gi>
      </n-grid>
      <p class="message">
        版权所有 © 2023 河南宸华环保科技有限公司 
        豫ICP备2023026336号-1   &nbsp;&nbsp;
        豫公网安备41052602000508号
      </p>
    </div>
  </div>
</template>
<script setup>
import router from "@/router";
import { ref } from "vue";

const toPage = (index) => {
  router.push({
    path: "Message",
    query: {
      index: index,
    },
  });
};
const toHome = () => {
  sessionStorage.setItem("menu", 1);
  router.push("/");
};
const toUS = () => {
  sessionStorage.setItem("menu", 2);
  router.push("/");
  setTimeout(() => {
    document.getElementById("isUS").scrollIntoView();
  }, 10);
};
const toProduct = () => {
  sessionStorage.setItem("menu", 3);
  router.push("Product");
};
const toTheCase = () => {
  sessionStorage.setItem("menu", 4);
  router.push("TheCase");
};
const toNews = () => {
  sessionStorage.setItem("menu", 5);
  router.push("News");
};
</script>
<style scoped>
#mainBody {
  height: 250px;
  background: #252525;
  margin-top: 7vh;
  color: #7e7e7e;
  padding: 40px 0 40px 0;
}
#mainBody p {
  line-height: 4vh;
}
.message {
  margin-top: 15px;
  text-align: center;
}
.list p {
  cursor: pointer;
}
p {
  font-size: 16px;
}
</style>